import ManageVehicles from './ManageVehicles'

export default ManageVehicles;